// extracted by mini-css-extract-plugin
module.exports = {"dialogPanel":"_3EibWG","alertTitle":"AOexb9","optionsWrapper":"_1kDr-D","optionButton":"_1ezSfb"};